import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function FileText({className, ...props}) {
  return (
    <div className={cx('icon', className)} {...props}>
      <svg width={'18px'} height={'22px'} viewBox={'0 0 18 22'}>
        <g
          stroke={'none'}
          strokeWidth={'1'}
          className={'icon__fill'}
          fillRule={'evenodd'}
        >
          <g transform={'translate(-3.000000, -1.000000)'} fillRule={'nonzero'}>
            <path
              d={
                'M14,1 C14.2652165,1 14.5195704,1.10535684 14.7071068,1.29289322 L20.7071068,7.29289322 C20.8946432,7.4804296 21,7.73478351 21,8 L21,20 C21,21.6568542 19.6568542,23 18,23 L6,23 C4.34314575,23 3,21.6568542 3,20 L3,4 C3,2.34314575 4.34314575,1 6,1 L14,1 Z M13.5857864,3 L6,3 C5.44771525,3 5,3.44771525 5,4 L5,20 C5,20.5522847 5.44771525,21 6,21 L18,21 C18.5522847,21 19,20.5522847 19,20 L19,8.41421356 L13.5857864,3 Z M15,7 L20,7 C20.5522847,7 21,7.44771525 21,8 C21,8.55228475 20.5522847,9 20,9 L14,9 C13.4477153,9 13,8.55228475 13,8 L13,2 C13,1.44771525 13.4477153,1 14,1 C14.5522847,1 15,1.44771525 15,2 L15,7 Z M16,12 C16.5522847,12 17,12.4477153 17,13 C17,13.5522847 16.5522847,14 16,14 L8,14 C7.44771525,14 7,13.5522847 7,13 C7,12.4477153 7.44771525,12 8,12 L16,12 Z M16,16 C16.5522847,16 17,16.4477153 17,17 C17,17.5522847 16.5522847,18 16,18 L8,18 C7.44771525,18 7,17.5522847 7,17 C7,16.4477153 7.44771525,16 8,16 L16,16 Z M10,8 C10.5522847,8 11,8.44771525 11,9 C11,9.55228475 10.5522847,10 10,10 L8,10 C7.44771525,10 7,9.55228475 7,9 C7,8.44771525 7.44771525,8 8,8 L10,8 Z'
              }
            ></path>
          </g>
        </g>
      </svg>
    </div>
  )
}

FileText.propTypes = {
  className: PropTypes.string,
}
